// src/components/mafia/minigames/intro/GameIntro.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaHourglassHalf } from 'react-icons/fa';
import { getIntroData } from './introConfig';
import './ArcadeShared.css'; // Используем общие стили

const GameIntro = ({ gameType }) => {
  const { t } = useTranslation();
  const content = getIntroData(gameType);

  return (
    <div className="mafia-overlay-bg">
      <div className="mafia-minigame-intro">

        <div className="intro-stamp">СЕКРЕТНО</div>

        <div className="intro-title">
           {t(content.title)}
        </div>

        <div className="intro-desc">
          {t(content.desc)}
        </div>

        <div style={{display: 'flex', justifyContent: 'center', margin: '25px 0'}}>
           <FaHourglassHalf className="hourglass-icon" />
        </div>

        <div style={{fontSize: '14px', color: '#888', fontStyle: 'italic'}}>
           {t('arcade.minigame_loading', 'Загрузка...')}
        </div>

      </div>
    </div>
  );
};

export default GameIntro;